import React, { useEffect, useState } from 'react';
import * as actionCreators from './../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Fade } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { validateCBU, validateCreditCard, verifyDateExpires, BINs } from '../../utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCreditCard, faFingerprint, faUser } from '@fortawesome/free-solid-svg-icons';
import { url, params, options } from '../../actions/webServices';
import Inputs from './../../Components/Inputs';
import SpinnerLoading from '../../Components/SpinnerLoading';
import axios from 'axios';
import { encryptPruCard } from '../../adapters/token.plugin';

function PayMethod({ payMethod, handleChange, firstStep, titularData, arrPayMethod, savePayMethod, codpmpol, cards, setLoading, loading, company }) {
  const { cardNumber, creditCard, fullName, dni, expires } = payMethod;
  const [mensaje, setMensaje] = useState(null);
  const [error, setError] = useState(false);
  const [optPayMethod, setOptPayMethod] = useState([]);
  const [idPayment, setIdPayment] = useState(null);
  const filterPayMethod = !firstStep.payMethod ? (firstStep.plan.includes("TARJETA") ? "TARJETA" : "CUPONERA") : null;
  const navigate = useNavigate();

  const validateTypeCard = async (cardNumber) => {
    const num = cardNumber.substring(0, 7).split(" ").join("");
    params.set('opcpm', 'binChecker');
    params.set('sec', firstStep.codsec.toString());
    params.set('bin', num);
    const res = await axios.post(url, params, options)
      .then(r => {
        //  console.log('r.data paymethod', r.data)
        if (r.data?.isCredit) {
          setMensaje(null);
          setError(false);
          setLoading(false);
          return true;
        }
        else return false;
      })
      .catch((r) => {
        console('error:', r);
        setMensaje(null);
        setError(false);
        setLoading(false);
        return false;
      });
    return res;
  }

  const encryptCard = async (cardNumber) => {
    let res = { data: cardNumber };
    if (process.env.NODE_ENV === 'production') {
      if (firstStep.codcia === 115) //Qualia 
        res = await axios.post('/php/encrypt.php', cardNumber.replaceAll(" ", ""))
    }
    //console.log(res.data)    
    return res.data.replace("\n", "");
  }

  const verifyForm = async (id) => {
    if (id === null || Number(id) === 0) {
      setMensaje('Ingrese un método de pago');
      return false;
    }
    if (id === 1) {  
      if (  (cardNumber.replaceAll(" ", "").length != 15  && payMethod.creditCard === "AMEX") || 
            (cardNumber.replaceAll(" ", "").length <= 15  && payMethod.creditCard !== "AMEX") ){
        setMensaje('Revise la cantidad de dígitos de la tarjeta');
        return false;
      }
      if (!creditCard) {
        setMensaje('Revise la entidad de su tarjeta de crédito');
        return false;
      }

      if (BINs.hasOwnProperty(payMethod.creditCard) && !BINs[payMethod.creditCard].some(cc => cardNumber.replaceAll(" ", "").startsWith(cc))) {
        setMensaje('Revise la entidad o el número de su tarjeta');
        return false;
      }

      const cardSplit = payMethod.cardNumber.split('')
      const bandera = cardSplit.some((number) => {
        if (!Number.isInteger(Number(number))) {
          return true
        }
      })
      if (bandera) {
        setMensaje('Revise el número de su tarjeta')
        return false
      }
      if (!cardNumber.replaceAll(" ", "").startsWith("589562")) { //Si no es Naranja
        if (!validateCreditCard(cardNumber)) {
          setMensaje('Revise el número de la tarjeta');
          return false;
        }
        const tcard = await validateTypeCard(cardNumber);
        if (!tcard) {
          if (payMethod.cardNumber[0] === "4" && firstStep.codsec === 57) {
            if (payMethod.creditCard !== "VISAD") {
              setMensaje('Elija la opción Tarjeta Visa (Débito)'); //Para que envíe el conducto correcto a QUALIA
              return false;
            }
          } else {
            setMensaje('Revise la tarjeta, solo se acepta crédito');
            return false;
          }
        } else {
          if (payMethod.cardNumber[0] === "4" && firstStep.codsec === 57) {
            if (payMethod.creditCard !== "VISA") {
              setMensaje('Elija la opción Tarjeta Visa '); //Para que envíe el conducto correcto a QUALIA
              return false;
            }
          }
        }
      }
      if (!fullName) {
        setMensaje('Revise su nombre');
        return false;
      }
      if (!dni) {
        setMensaje('Revise el DNI');
        return false;
      }
      if (!expires || !verifyDateExpires(expires)) {
        setMensaje('Revise la expiración');
        return false;
      }
    }
    if (id === 2) {
      if (!cardNumber || !validateCBU(cardNumber)) {
        setMensaje('Revise el CBU');
        return false;
      }
    }
    return true;
  }

  const searchIdPayment = (e) => {
    setMensaje(null);
    setError(false);
    let id
    if (firstStep.codsec === 32) {
      id = arrPayMethod.find(item => (
        item.id === e.value
      ));
    } else {
      id = arrPayMethod.find(item => (
        item.value === e.value &&
        item.codpro === firstStep.codpro
      ));
    }
    setIdPayment(id.id);
    handleChange({ step: "payMethod", target: { name: 'id', value: id.id } });
    handleChange({ step: "payMethod", target: { name: 'creditCard', value: '' } });
    handleChange({ step: "payMethod", target: { name: 'cardNumber', value: '' } });
    handleChange({ step: "payMethod", target: { name: 'expires', value: '' } });
  }

  const handleSubmit = async () => {
    setLoading(true);
    const isValid = await verifyForm(idPayment);
    const cardNumber = await encryptCard(payMethod.cardNumber);
    let encryptedNumber = ""
    if (firstStep.codcia === 88) encryptedNumber = await encryptPruCard(cardNumber)
    if (isValid) {
      setError(false);
      savePayMethod({
        ...payMethod,
        payMethod: firstStep.payMethod,
        price: firstStep.price,
        lastNumbers: payMethod.cardNumber.toString().slice(-4),
        cardNumber,
        encryptedNumber,
        tarjetaPlana: payMethod.cardNumber,
      }, codpmpol);
      navigate('/qs/confirm');
    } else {
      setError(true);
    }
    setLoading(false);
  }

  const normalizeCC = (e) => {
    const val = e.target.value;
    if (idPayment === 1) {
      e.target.value = val.replace(/\s/g, "").match(/.{1,4}/g)?.join(" ").substr(0, 19) || ""
    }
    if (idPayment === 2) e.target.value = val.substr(0, 22);
  }

  const normalizeDate = (e) => e.target.value = e.target.value.replace(/\D/g, '').replace(/(\d{2})(\d)/, '$1/$2').replace(/(\d{2})(\d)/, '$1/$2');

  const normalizeDNI = (e) => e.target.value = e.target.value.replace(/\D/g, '').replace(/(\d{2})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2');

  useEffect(() => {
    handleChange({ step: "payMethod", target: { name: 'dni', value: firstStep.dni } });
    handleChange({ step: "payMethod", target: { name: 'fullName', value: `${titularData.name} ${titularData.lastname}` } });
    if (firstStep.type === 'moto') {
      setIdPayment(Number(firstStep.payMethod));
      handleChange({ step: "payMethod", target: { name: 'id', value: Number(firstStep.payMethod) } });
    } else {
      const id = arrPayMethod.find(item => item.value === Number(firstStep.payMethod) && item.codpro === firstStep.codpro);
      id && setIdPayment(id.id);
    }
  }, [codpmpol]);

  useEffect(() => {
    codpmpol === "" && navigate("/");
  }, []);

  useEffect(() => {
    setOptPayMethod([]);
    const res = [];
    arrPayMethod?.forEach(item => {
      if (firstStep.codsec === 32) {
        if (Number(item.codsec) === firstStep.codsec)
          res.push({
            value: item.value,
            label: item.label,
          });
      } else {
        if (item.codpro === firstStep.codpro)
          res.push({
            value: item.value,
            label: item.label,
          });
      }
    })
    if (firstStep.codsec === 32) {
      let found;
      if (company === 4 || company === 54) {
        found = arrPayMethod.find((e) => e.value === firstStep.payMethod && e.codsec === '32');
        setOptPayMethod((prevState) => [...prevState, found]);
      } else {
        found = arrPayMethod.find((e) => e.label.includes(filterPayMethod) && e.codsec === '32');
        setOptPayMethod((prevState) => [...prevState, { label: found?.label, value: found?.id }]);
      }
    }
    else setOptPayMethod(res);


  }, [codpmpol])

  useEffect(() => {
    const uniquePayMethod = arrPayMethod.filter((e) => e.codpro === firstStep.codpro)
    if (uniquePayMethod?.length === 1) {
      searchIdPayment(uniquePayMethod[0])
      handleChange({ step: "firstStep", target: { name: 'payMethod', value: uniquePayMethod[0]?.value } });
    }
  }, [])

  return (
    <Fade appear in>
      <div className="qs qsmargin res-payment">
        <div className="container max-shadow">
          <div className='d-flex flex-column m-0 mb-4 scroll-off'>
            <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>FORMA DE PAGO</h1>
            <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
          </div>
          <div className="qs-inputs row row-cols-2">
            <Inputs
              title={"Tipo de pago"}
              name={'payMethod'}
              type={'select'}
              options={optPayMethod}
              value={firstStep.payMethod}
              step={'firstStep'}
              change={searchIdPayment}
            />
            {
              idPayment === 1 ? (
                <>
                  <Inputs
                    title={"Tarjeta de crédito"}
                    name={'creditCard'}
                    type={'select'}
                    options={
                      cards
                        .filter(card => card['cod-cia'] === firstStep.codcia && card['cod-sec'] === firstStep.codsec)
                        .sort((a, b) => a['ord-pst'] - b['ord-pst'])
                    }
                    value={payMethod.creditCard}
                    step={'payMethod'}
                  // disabled={payMethod.cardNumber.length >= 1}
                  />
                  <Inputs
                    title={"Número de tarjeta"}
                    name={'cardNumber'}
                    type={'tel'}
                    change={normalizeCC}
                    value={payMethod.cardNumber}
                    step={'payMethod'}
                    icon={<FontAwesomeIcon icon={faCreditCard} />}
                  />
                  <Inputs
                    title={"Nombre y Apellido"}
                    name={'fullName'}
                    value={payMethod.fullName}
                    step={'payMethod'}
                    icon={<FontAwesomeIcon icon={faUser} />}
                  />
                  <Inputs
                    title={"DNI"}
                    name={'dni'}
                    type={'text'}
                    change={normalizeDNI}
                    maxLength={10}
                    value={payMethod.dni}
                    step={'payMethod'}
                    icon={<FontAwesomeIcon icon={faFingerprint} />}
                  />
                  <Inputs
                    title={"Fecha de vencimiento"}
                    name={'expires'}
                    value={payMethod.expires}
                    step={'payMethod'}
                    change={normalizeDate}
                    maxLength={5}
                    icon={<FontAwesomeIcon icon={faCalendarDays} />}
                  />
                </>
              ) : (
                idPayment === 2 && (
                  <Inputs
                    title={"CBU"}
                    name={'cardNumber'}
                    type={'tel'}
                    change={normalizeCC}
                    value={payMethod.cardNumber}
                    step={'payMethod'}
                  />
                )
              )
            }
            <Inputs
              title={"Premio Mensual"}
              value={`$ ${Number(firstStep.price)?.toFixed(2)}`}
              step={'payMethod'}
              disabled
            />
          </div>
          {
            error &&
            <Alert className='mt-2' variant={'danger'}>
              {mensaje}
            </Alert>
          }
          <div className='row flexend'>
            <div className="col-sm-6 col-lg-4 offset-lg-4 offset-md-3">
              {loading
                ? <SpinnerLoading />
                :
                <Inputs
                  type={'button'}
                  title="Continuar"
                  onClick={handleSubmit}
                />
              }
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

function mapStateToProps(state) {
  return {
    payMethod: state.mainReducer.payMethod,
    titularData: state.mainReducer.titularData,
    firstStep: state.mainReducer.firstStep,
    arrPayMethod: state.mainReducer.arrPayMethod,
    codpmpol: state.mainReducer.codpmpol,
    cards: state.mainReducer.cards,
    loading: state.mainReducer.loading,
    company: state.mainReducer.company,
  }
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PayMethod);
